import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useOrganizationsGeneralInfoQuery } from "@/graphql"
import { PaymentOverdueContent } from "@/helpers/orgSession"
import { Col, Row } from "antd"
import { FC } from "react"
import "../choose-portal/ChoosePortal.less"
import "../outgoing-only-portal/OutgoingOnlyPortal.less"

const { Title, Paragraph } = WebsiteTypography

const SUPPORT_EMAIL = "support@easetech.co.za"

const capitalize = (slug: string) => slug.charAt(0).toUpperCase() + slug.slice(1)

/**
 * Shown to staff (any role but client) of an organization flagged with outstanding payments: on sign-in (the CMS
 * refuses the session) or when an older session reaches the dashboard (DashboardLayout signs it out). Clients of
 * the organization are not affected and never see it.
 */
const PaymentOverdue: FC = () => {
  const { modalDarkContent, setIsModalDarkOpen } = useModalDarkContext()
  const { orgSlug } = (modalDarkContent ?? {}) as PaymentOverdueContent

  const { data } = useOrganizationsGeneralInfoQuery({
    variables: { filter: { slug: { eq: orgSlug } } },
    skip: !orgSlug,
  })
  const orgName = data?.organizations?.data?.[0]?.attributes?.name || capitalize(orgSlug ?? "")
  const subject = encodeURIComponent(`Outstanding account — ${orgName}`)

  return (
    <Row justify={"center"} className={"choose-portal-wrapper outgoing-only-portal-wrapper"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered className={"section-title"}>
          <span className={"w300"}>{"Outstanding "}</span>
          <span className={"bold"}>{"Account"}</span>
        </Title>

        <Row justify={"center"}>
          <Col span={18} xxl={18} xl={18} lg={18} md={22} sm={24} xs={24}>
            <Paragraph centered size={"md"} style={{ paddingTop: 24 }} color={"website-secondary"} weight={"w300"}>
              {"Your company has outstanding payments that must be settled before you can access the system."}
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <DividerWithHex />

      <Row justify={"center"}>
        <Col span={18} xxl={18} xl={18} lg={18} md={22} sm={24} xs={24}>
          <Paragraph weight={"w300"} size={"sm"} color={"website-secondary"} centered>
            {"To arrange payment or query the outstanding balance, please contact Easetech: "}
            <a href={`mailto:${SUPPORT_EMAIL}?subject=${subject}`} className={"support-email-link"}>
              {SUPPORT_EMAIL}
            </a>
          </Paragraph>
          <Paragraph weight={"w300"} size={"sm"} color={"website-secondary"} centered style={{ paddingTop: 16 }}>
            {`Access will be restored once the outstanding balance has been settled. Applicants submitting applications are not affected by this restriction.`}
          </Paragraph>
        </Col>
      </Row>

      <Row justify={"center"} style={{ marginTop: 32 }}>
        <Button btnType={"primary"} text={"CLOSE"} onClick={() => setIsModalDarkOpen(false)} />
      </Row>
    </Row>
  )
}

export default PaymentOverdue
